import React, { useCallback, useEffect } from "react"
import PropTypes from "prop-types"
import InputLabel from "@material-ui/core/InputLabel"
import MenuItem from "@material-ui/core/MenuItem"
import Select from "@material-ui/core/Select"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import { makeStyles, useTheme } from "@material-ui/core/styles"

// The value the master firmware expects to receive for a specific generation and board version.
// Gen3.0 means board version 2.7 or 2.8. Gen3.1 means board version 2.9.
// First byte: CPU type
// Second byte: Board gen
const WindSensorTypes = ["IN_SPEED", "ET_40RS", "ET_3250", "BARANI"]
export const useStyles = makeStyles((_theme) => ({
	outer: {
		display: "table",
		border: "1px solid #CCC",
		borderRadius: "4px",
		boxSizing: "border-box",
		padding: "10px",
		textAlign: "left",
		marginTop: "5px",
		marginBottom: "5px",
		width: "100%",
	},
}))

const WindSensorTypeSelector = (props) => {
	const { value, setValue } = props
	const classes = useStyles()
	const theme = useTheme()
	const isMobileView = useMediaQuery(theme.breakpoints.down("sm"))
	useEffect(() => {
		if (!value) {
			setValue(WindSensorTypes[0])
		}
	}, [value, setValue])

	const handleWindSensorTypeChanged = useCallback(
		(e) => {
			setValue(e.target.value)
		},
		[setValue],
	)

	return (
		<div className={classes.outer}>
			<InputLabel id="windSensor">Select Wind Sensor type</InputLabel>
			<Select
				value={value}
				defaultValue={WindSensorTypes[0]}
				label={"Select Wind Sensor type"}
				labelId="windSensor"
				onChange={handleWindSensorTypeChanged}
				style={{ width: "100%", height: "40px" }}
				MenuProps={{
					anchorOrigin: {
						vertical: "bottom",
						horizontal: "center",
					},
					transformOrigin: {
						vertical: isMobileView ? "bottom" : "top",
						horizontal: "center",
					},
				}}
			>
				{WindSensorTypes.map((sensorType) => (
					<MenuItem value={sensorType} key={sensorType}>
						{sensorType}
					</MenuItem>
				))}
			</Select>
		</div>
	)
}

WindSensorTypeSelector.propTypes = {
	setValue: PropTypes.func.isRequired,
	value: PropTypes.number.isRequired,
}

export default WindSensorTypeSelector
